import { render, staticRenderFns } from "./hostCalculation.vue?vue&type=template&id=2a3ba5ef&scoped=true"
import script from "./hostCalculation.vue?vue&type=script&lang=js"
export * from "./hostCalculation.vue?vue&type=script&lang=js"
import style0 from "./hostCalculation.vue?vue&type=style&index=0&id=2a3ba5ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3ba5ef",
  null
  
)

export default component.exports